<template>
	<div id="app">
		<a-config-provider :locale="locale">
			<router-view></router-view>
		</a-config-provider>
	</div>
</template>

<script>
	import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
	export default {
		name: 'App',
		data() {
			return {
				locale: zhCN,
			};
		},
		mounted() {
			window.addEventListener('message', this.handleMessage);
		},
		beforeDestroy() {
			window.removeEventListener('message', this.handleMessage);
		},
		async created() {
			// document.getElementById("woyaou-loading").remove();
			this.getConfig()
			await this.setUserInfo()
			await this.setTeacherInfo()
			if (localStorage.getItem('account-token')) {
				// 获取所有的 cookies
				const cookies = document.cookie.split('; ');

				// 设置过期时间为过去的时间（用于删除 cookie）
				const expires = new Date();
				expires.setTime(expires.getTime() - 1);

				// 判断是否存在 token
				let tokenExists = false;
				cookies.forEach(cookie => {
					if (cookie.startsWith('token=')) {
						tokenExists = true;
					}
				});

				// 如果存在 token，删除它
				if (tokenExists) {
					document.cookie = `token=; expires=${expires.toUTCString()}; path=/`;
				}

				// 存储新的 token
				document.cookie =
					`token=${localStorage.getItem('account-token')}; expires=${localStorage.getItem('access_token_expire')}; path=/`; // 设置7天后过期ken=${localStorage.getItem('account-token')}`;

				console.log("cookies==", document.cookie);
				
				if(!localStorage.getItem('currency')){
					localStorage.setItem('currency','HK$')
				}
			}
		},
		methods: {
			// 获取全局配置信息
			getConfig() {
				this.$http.api('index/config').then(res => {
					console.log("配置信息", res);
					localStorage.setItem('client_id', res.info.client_id)
					localStorage.setItem('crouseTime', res.info.crouseTime) //课程时长
					localStorage.setItem('experienceCrouseTime', res.info.experienceCrouseTime) //体验课时长
					localStorage.setItem('webLogo', res.info.webLogo) //体验课时长
					
				}).catch(err => {
					console.log("err", err);
				})
			},
			handleMessage(event) {
				// 安全检查：验证消息来源（可选但推荐）
				// if (event.origin !== 'https://www.mirastudent.com') return;
				console.log("接收到了",event);
				if (event.data.type === 'CONDITION_MET') {
					this.yourMethod(event.data.data);
				}
			},
			yourMethod(data) {
				// 处理来自网页 A 的消息
				console.log('没登陆网页:', data);
				this.$router.push('/login')
			}
		}
	}
</script>

<style scoped>
	@import url('assets/css/iconfont/iconfont.css');
	@import url('assets/css/bootstrap/dist/css/bootstrap.css');

	html {
		font-size: 1rem;
		color: #242424 !important;
	}
	.ant-tabs-nav .ant-tabs-tab {
		font-size: 16px;
	}
	
	.ant-tabs-nav .ant-tabs-tab:hover {
		color: #52C4C9;
	}
	
	.ant-tabs-nav .ant-tabs-tab-active {
		color: #52C4C9;
		text-shadow: 0 0 0.25px #52C4C9
	}
	
	.ant-tabs-ink-bar {
		background-color: #52C4C9;
	}
</style>